import React from 'react';
import styles from './index.less';

interface IDetailCardProps {
  item: {
    cover: string;
    title: string;
    vipId: string;
  },
  showAuthor?: boolean
}

const DetailCard: React.FC<IDetailCardProps> = ({
  item,
  showAuthor = true
}) => {
  return (
    <div className={styles.index}>
      <div
        className={styles.cover}
        style={{
          backgroundImage: `url(${item.cover})`
        }}
      >
        <div className={styles.btn}></div>
      </div>
      <div className={styles.title}>
        {item.title}
      </div>
      {showAuthor && <div className={styles.author}>
        {item.vipId?.replace(/,/ig, ' ')}
      </div>}

    </div>
  );
};

export default DetailCard;